var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5V21.8516H19.6484V19.5H22ZM22 14.8516V17.1484H19.6484V14.8516H22ZM24.3516 24.1484V12.5H15V14.8516H17.3516V17.1484H15V19.5H17.3516V21.8516H15V24.1484H24.3516ZM12.6484 10.1484V7.85156H10.3516V10.1484H12.6484ZM12.6484 14.8516V12.5H10.3516V14.8516H12.6484ZM12.6484 19.5V17.1484H10.3516V19.5H12.6484ZM12.6484 24.1484V21.8516H10.3516V24.1484H12.6484ZM8 10.1484V7.85156H5.64844V10.1484H8ZM8 14.8516V12.5H5.64844V14.8516H8ZM8 19.5V17.1484H5.64844V19.5H8ZM8 24.1484V21.8516H5.64844V24.1484H8ZM15 10.1484H26.6484V26.5H3.35156V5.5H15V10.1484Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.29b5953a79562e7e7267196895d4ee11.svg";
export { ForwardRef as ReactComponent };